import React from "react";
import "./style.css";

const PrivacyPolicyDescription = ({ title, description }) => (
  <section className="privacy-policy-section section-padding">
    <div className="container">
      <div className="row">
        <div className="col col-xs-12">
          <div className="content clearfix">
            <div className="error-message">
              <h1>{title}</h1>

              <p
              className="text-align-left"
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
export default PrivacyPolicyDescription;
